/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimAuthenticationDetailsResponseDto } from '../models/clm-claim-authentication-details-response-dto';


/**
 * the ClaQueryReadAuthenticationDetails API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryReadAuthenticationDetailsService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation claimClaimIdAuthenticationDetailsGet
   */
  static readonly ClaimClaimIdAuthenticationDetailsGetPath = '/claim/{claimId}/authentication/details';

  /**
   * Get authenticate details for claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `claimClaimIdAuthenticationDetailsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdAuthenticationDetailsGet$Response(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmClaimAuthenticationDetailsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryReadAuthenticationDetailsService.ClaimClaimIdAuthenticationDetailsGetPath, 'get');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.query('language', params.language, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmClaimAuthenticationDetailsResponseDto>;
      })
    );
  }

  /**
   * Get authenticate details for claim.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `claimClaimIdAuthenticationDetailsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  claimClaimIdAuthenticationDetailsGet(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<ClmClaimAuthenticationDetailsResponseDto> {

    return this.claimClaimIdAuthenticationDetailsGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmClaimAuthenticationDetailsResponseDto>) => r.body as ClmClaimAuthenticationDetailsResponseDto)
    );
  }

}
